import classNames from 'classnames';

import { Badge } from '@components/badge/Badge';
import { ClippedImage } from '@components/clippedImage/ClippedImage';
import { Markdown } from '@components/markdown/Markdown';
import { TextMarquee } from '@components/textMarquee/TextMarquee';

import { ElsewherePresentsVenueRecord } from '@interfaces';

import styles from './venue-preview.module.scss';

interface VenuePreviewProps extends ElsewherePresentsVenueRecord {
	isResponsive?: boolean;
	isCompact?: boolean;
	sizes?: string;
	className?: string;
	headingTag?: 'h2' | 'h3';
	isElsewherePresents?: boolean;
}

export const VenuePreview = ({
	id,
	title,
	isElsewherePresents,
	description,
	website,
	isResponsive = true,
	clippedImage,
	sizes = '100vw',
	className,
	headingTag = 'h3',
}: VenuePreviewProps) => {
	const text = description;
	const HeadingTag = headingTag as keyof JSX.IntrinsicElements;

	return (
		<article
			className={classNames(className, styles['venue-preview'], {
				[styles['venue-preview--is-responsive']]: isResponsive,
			})}
			key={id}
		>
			<div className={styles['venue-preview__body']}>
				<HeadingTag className={styles['venue-preview__heading']}>
					<Badge isElsewherePresents key={id} tag="div">
						{isElsewherePresents ? (
							<TextMarquee isElsewherePresentsVenue text={`↗ ${title}`} />
						) : (
							title
						)}
					</Badge>
				</HeadingTag>
			</div>
			{text ? (
				<Markdown className={styles['venue-preview__text']} text={text} />
			) : null}
			<ClippedImage
				className={styles['venue-preview__image']}
				{...clippedImage}
				sizes={sizes}
			/>
			{website ? (
				<Markdown className={styles['venue-preview__website']} text={website} />
			) : null}
		</article>
	);
};
